/**
 * 抽象门店模块和门店列表模块 导航功能
 * @param {Vue} vueInstance
 * @param {@type import('../services').storeInfo} storeInfo
 */
export function goMapRouter(vueInstance, storeInfo) {
  const {
    storeName: desc,
    longitude: lng,
    latitude: lat,
    distanceKm: distance,
    addressStreet: address
  } = storeInfo
  // console.log(desc, lng, lat)
  vueInstance.$router.push({
    name: 'map',
    query: {
      lng,
      lat,
      desc,
      distance,
      address
    }
  })
}
